import { createSelector } from "@reduxjs/toolkit";
import { depotsDropdownMapper } from "../../models/depot";
import { getSelectedDepot } from "../ownApp/selectors";
import {
  LOCK_OVERRIDE_ACCESS,
  MAP_ACCESS,
  SECTION_ACCESS,
  SHIFT_MANAGERS_ACCESS,
  ROUTE_ACCESS,
  PLAN_ACCESS,
} from "../../consts/userRoles";

export const isUserLoading = (state) => state.ownUser.loading;

export const userError = (state) => state.ownUser.error;

export const getUserMetadata = (state) => state.ownUser.metadata;

export const getUserDepots = createSelector(getUserMetadata, (userMetadata) => {
  if (!userMetadata?.depotAccess) return [];
  else return userMetadata.depotAccess;
});

export const hasForcePlanAdminRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(PLAN_ACCESS)
);

export const hasForceUnlockMatrixRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(LOCK_OVERRIDE_ACCESS)
);

export const hasMapAdminRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(MAP_ACCESS)
);

export const hasSectionAdminRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(SECTION_ACCESS)
);

export const hasShiftManagerAdminRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(SHIFT_MANAGERS_ACCESS)
);

export const hasRouteAdminRoleSelector = createSelector(
  getUserMetadata,
  (userMetadata) =>
    userMetadata?.roles && userMetadata.roles.includes(ROUTE_ACCESS)
);

export const getDepotsForDropDown = createSelector(getUserDepots, (depots) =>
  depotsDropdownMapper(depots)
);

export const getSelectedDepotDetails = createSelector(
  getUserDepots,
  getSelectedDepot,
  (depots, selectedDepot) => {
    if (!depots || depots.length === 0 || !selectedDepot) {
      return null;
    }

    return depots.find((depot) => {
      return depot.depotCode === selectedDepot;
    });
  }
);
